import React, { Component } from 'react'
import '../ProjectView/style.css'
import './style.css'
import {Link} from 'react-router-dom'
import 'font-awesome/css/font-awesome.min.css';
// import background from "../../public/images/massage-hero.png";

class DetailsMassage extends Component {
  componentDidMount(){
    window.scrollTo(0, 0);
  }

  render(){
    return(
      <div>
        <div className="header" style={{  backgroundImage: `url(${process.env.PUBLIC_URL + '/images/massage-hero.png'})` }}>
          <Link to='/'>
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </Link>
          <h3 className="date" style={{color: "#38AAE8"}}>Spring 2021</h3>
          <h1>Prototyping features for new, mini user interactions of a massage gun</h1>
          <h3>IDEO Products & Services • Animation / Interaction Design</h3>
        </div>
        <div className="main">
          <p className="summary">In collaboration with a massage gun manufacturer, a previous IDEO team had worked on the physical design of their new flagship massage gun device.
          The physical design included a 1" x 2" touchscreen, but what features could you offer with a touchscreen on a massage gun?
          <br/><br/>
          My team was brought in to explore potential feature sets and create the interaction paradigms for this new device.</p>
          <div className="lists" style={{width: "100%"}}>
            <h2>The Challenge</h2>
            <ol>
              <li>To identify opportunity areas and desireable use cases for a WiFi-enabled massage gun</li>
              <li>To design and prototype the vision for the digital massage gun experience, from onboarding to menu selection</li>
              <li>To draft animations and system architecture to ensure rapid sprint to market (product was launched 6 months after our project)</li>
            </ol>
          </div>
          
          <img src={process.env.PUBLIC_URL + '/images/massage-puppet.gif'} />
        
        <h2>Research</h2>
          <p>
            To test potential new feature sets, we needed to make sure that we were giving our participants a real understanding of the size of the screen,
            and what the interactions might feel like. As we were in early explorations, we needed a cheap and scalable solution.
            So, for each participant, we sent a 3D printed model with a clickable button, and instructions on opening a Figma prototype on their phone, which was scaled to the physical size the screen would be.
            Holding each in one hand, we had the participants to go through the experience to make sure that we conveyed the scale and ergonomics of the interaction.
          {/* <img src={process.env.PUBLIC_URL + '/images/ARPokemon/BattleInterface-Collapsed.png'} /> */}
</p>
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/3d.png'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/main-menu.gif'} />
          <p className="subtitle">Our research model + scaled interactive prototype</p>
          
          <h2>Design</h2>
        <img src={process.env.PUBLIC_URL + '/images/figma.png'} />
          <p className="subtitle">Initial Explorations using Figma</p>
          <p>
          As we were designing for such unique platform with new interaction paradigms, we found that tools like Figma were limiting the ways we were communicating 
          the rhythm outputs of the device.
          So we experimented with prototyping in After Effects. And with many experiments on how we might visually depict rhythms, we settled on the Aura circle to communicate 
          the motor strength rhythms of the device. 
          And as our works-like prototype could display GIFs, this made for a natural export from After Effects to immediately testing how these animations would look on the device itself.
        </p>
        <img src={process.env.PUBLIC_URL + '/images/rhythms.gif'} />
        <p className="subtitle">Final Explorations using After Effects</p>


        <h2>Prototyping</h2>
        <p>
          Due to our client's quick turnaround from design to product launch, we wanted to ensure that our design was heavily considering
          technical constraints that would emerge during development.
          Therefore, our design team challenged ourselves to build a high fidelity works-like prototype.
          </p>
          <img src={process.env.PUBLIC_URL + '/images/massage-model.png'} />
        <p className="subtitle">Guts Prototype + Closed Box Prototype</p>
        <p>
          Our hardware stream focused on developing a working physical model (with working screen and motor), our interaction design stream focused on building a digital clone of the device in Unity.
          Using a technique we call "digital puppeteering", we developed a prototype experience where the states of a mobile app and the hardware prototype were synced.
          In our final demo, I recorded a video with our physical model in my right hand (on camera) and the mobile app in my left hand (off camera).
          I would do the same gestures in both hands, so swipes and taps on the mobile app would send a state signal to the physical model, playing a GIF of the interaction, 
          and pressing the button on the physical model would send a state signal to the mobile app, which would send back the appropriate state and activate the motor.

          This digital puppeteering prototype conveyed what the on-device experience could be and was robust and simple enough to control so our client could use it in their own presentations.

        </p>
          <img src={process.env.PUBLIC_URL + '/images/massage-puppet.gif'} />
 
        <h2>The Work in the Public</h2>
            <a href="https://www.fastcompany.com/90731859/this-smart-massage-gun-knows-exactly-what-your-body-wants" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://images.fastcompany.net/image/upload/w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/wp-cms/uploads/2022/03/p-1-lyric-percusive-massager-90731859-lyric.webp'} />
                <h4>Fast Company</h4>
                <h3>This smart massage gun knows exactly what your body wants</h3>
              </div>
            </a>
            <a href="https://design-milk.com/lyric-soothes-muscles-and-defeats-eyesores/" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://design-milk.com/images/2022/04/Lyric-Massage-Gun-4.jpg'} />
                <h4>Design Milk</h4>
                <h3>Lyric Soothes Muscles and Defeats Eyesores</h3>
              </div>
            </a>
            <a href="https://nypost.com/2021/12/02/forget-massage-guns-this-rhythm-therapy-device-is-next-level/" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://nypost.com/wp-content/uploads/sites/2/2021/12/massage-gun.jpg?quality=75&strip=all&w=1388'} />
                <h4>New York Post</h4>
                <h3>This rhythm therapy device is even better than a massage gun</h3>
              </div>
            </a>
            <a href="https://www.entrepreneur.com/article/414272" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://assets.entrepreneur.com/content/3x2/2000/1642706761-Ent-Lyric.png?auto=webp&quality=95&crop=16:9&width=675'} />
                <h4>Entrepreneur</h4>
                <h3>I Found a Simple Way to De-stress During the Busiest Workdays: Rhythm Therapy</h3>
              </div>
            </a>
        </div>
      </div>
    )
  }
}

export default DetailsMassage



// WEBPACK FOOTER //
// ./src/components/ProjectDetailPage/project-massage.js